module.exports = __webpack_public_path__ + "img/Bitmap.20eae43a.png";